jQuery('.featured__wrapper').on('mouseover', function(){
	jQuery(this).addClass('is-active');
});

jQuery('.featured__wrapper').on('mouseout', function(){
	jQuery(this).removeClass('is-active');
});